module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('a', {
    attrs: {
      "id": "page_1"
    }
  }), _vm._v(" "), _c('h2', {
    staticClass: "cn"
  }, [_vm._v("Chapter 1")]), _vm._v(" "), _c('h2', {
    staticClass: "ct"
  }, [_vm._v("Foundations")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Palestine forms a small section of the Fertile Crescent that extends from the Persian Gulf, along the plains and valleys of the Tigris and the Euphrates rivers to the Anatolian plateau, before bending south-westerly along the eastern coast of the Mediterranean Sea. The cultivatable land of this crescent was the birthplace of some of the earliest Asian civilizations. Wedged between the Mediterranean in the west and the Transjordanian highlands in the east, Palestine was the land bridge forming the trade routes between Africa and Asia.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The principal international highway, the"), _c('em', {
    staticClass: "italic"
  }, [_vm._v(" Way of the Sea")]), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/35_Notes#fn1-1",
      "id": "rfn1-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1")])]), _vm._v(" or "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("via maris")]), _vm._v(", meandered northwards from Egypt along Palestine’s Mediterranean coast (see "), _c('span', {
    attrs: {
      "href": "#/xhtml/38_Plates#fig1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("figure 1")]), _vm._v("). At Megiddo there was an intersection with the main Transjordan trade route, before the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Way of the Sea")]), _vm._v(" continued its coastal path to destinations that included Anatolia, Syria and Mesopotamia. The road was, however, fraught with danger, as travellers and traders were exposed to pirates and thieves and possible aggression from any ill-disposed peoples residing along the route.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The Judean hill country afforded a greater degree of security for interchange between the south and north along a ridge, on either side of which were steep meandering valleys. This key secondary road followed the north–south watershed from Shechem to Hebron and on to Beer-Sheba. There were intersecting crossroads where valleys cut into the hills from the coastal plains to the west and the Jordan Rift Valley to the east. Sited on this route, just to the south of where the column of hills turns slightly to the west, was Jerusalem.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In its earliest manifestation, what in the passage of time was to become the south-eastern hill (the Ophel) of Jerusalem, was the home of its first known settlers. The Ophel was well protected on the east by the precipitous Kidron Valley, which joined the deep Hinnom Valley on the southern side. To the west was the Tyropoeon Valley and to the north "), _c('a', {
    attrs: {
      "id": "page_2"
    }
  }), _vm._v("was a low saddle leading to another hill, which later became known as Mt Moriah.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Precipitation in Palestine is quite predictable, with hardly any rainfall between May and October, but fairly plentiful from November through to March. Jerusalem receives approximately twenty-five inches of rain annually, but this is absorbed by the abundant soft porous limestone rock, obviating the materialization of any local brooks or ponds. The so-called late rains comprise moderate showers during April and early May, which help local crops to reach full maturity. As well as the defensive qualities afforded by the surrounding steep valleys, a primary reason for the development of a settlement in Jerusalem was the proximity of an enduring source of water – the Gihon Spring."), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/35_Notes#fn1-2",
      "id": "rfn1-2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("A relatively unimportant spring, En Rogel,"), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/35_Notes#fn1-3",
      "id": "rfn1-3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3")])]), _vm._v(" was situated close to the convergence of the Hinnom and Kidron Valleys, but for most of the year it had to be used as a well."), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/35_Notes#fn1-4",
      "id": "rfn1-4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4")])]), _vm._v(" It was of limited value to any permanent settlement, as the amount of water it provided was small and it would have been difficult to defend."), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/35_Notes#fn1-5",
      "id": "rfn1-5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5")])]), _vm._v(" Discounting the small yield from En Rogel, ancient Jerusalem’s only stable water supply was the Gihon Spring,"), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/35_Notes#fn1-6",
      "id": "rfn1-6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6")])]), _vm._v(" situated on the banks of the Kidron Valley, at the foot of the eastern slope of the early Jerusalem settlement. The Gihon Spring is fed by groundwater that accumulates in a subterranean cave, and each time that it fills to the brim, it empties through cracks in the rock and is siphoned to the surface. This natural feature made it necessary to accumulate water in a pool, to be available when the spring was not gushing forth.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("There is archaeological evidence demonstrating the existence of a ‘presence’ on the Ophel in the Early Bronze Age (c.3200–2300 "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("BCE")]), _vm._v("), with further indications of habitation in caves or mud huts lower down on the eastern slope."), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/35_Notes#fn1-7",
      "id": "rfn1-7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7")])]), _vm._v(" Archaeological remains indicate a similar situation in the Middle Bronze Age (c.2200–1550 "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("BCE")]), _vm._v("), with probably a small settlement on the Ophel, extending down the eastern incline to the Gihon Spring. This changed dramatically during the Late Bronze Age (c.1550–1200 "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("BCE")]), _vm._v(") with the construction of a system of artificial terraces that enabled more sophisticated houses to be built on the slopes leading down to the Kidron Valley. As the terraces were, however, prone to subsidence, they needed constant maintenance."), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/35_Notes#fn1-8",
      "id": "rfn1-8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In the mid-fifteenth century "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("BCE")]), _vm._v(", Egyptian Pharaoh Thutmose III began military action against a number of small city-states who viewed the alternative north-eastern Syrian superpower, the Mitanni, as their ultimate "), _c('a', {
    attrs: {
      "id": "page_3"
    }
  }), _vm._v("overlord. The dual purpose of the campaign was to ensure access to resources such as cedar, copper and tin from the coastal regions of "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Djahy")]), _vm._v(","), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/35_Notes#fn1-9",
      "id": "rfn1-9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9")])]), _vm._v(" and also to gain control over the vital trade routes that passed through the Levant."), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/35_Notes#fn1-10",
      "id": "rfn1-10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10")])]), _vm._v(" At the Battle of Megiddo, Thutmose defeated a coalition of Canaanite tribes and established Egyptian dominance over Palestine."), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/35_Notes#fn1-11",
      "id": "rfn1-11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11")])]), _vm._v(" In order to ensure the continuation of Egyptian authority, local vassal governors were appointed to the individual Syro-Palestinian city-states.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The power and influence of the Mitanni, however, had not been dissipated and there were numerous rebellions by city-states seeking to switch their allegiances. Thutmose III and his late-fifteenth-century successor, Amenhotep II, had to undertake regular military excursions in order to maintain Egyptian hegemony over Palestine. The emergence of a rival regional super-power, the Hittites, fostered a change in the relationship between the Egyptians and the Mitanni from conflict to peaceful alliance and, for the former, an era of peace and prosperity ensued. Insights into the international system in place during the fourteenth century "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("BCE")]), _vm._v(" have been afforded by the discovery of an archive referred to as the Amarna Letters."), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/35_Notes#fn1-12",
      "id": "rfn1-12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("A number of these clay tablets, providing the earliest known literary references to Jerusalem and Bethlehem, were written to the rulers of Egypt by their client prince in Jerusalem, Abdi-Heba. The Jerusalem dignitary begs for assistance against of marauding outlaws, complains that Egyptian slave-troops (or mercenaries) have burgled his own house, and describes the anarchic conditions prevailing in Palestine in general and locally in Bethlehem:")]), _vm._v(" "), _c('div', {
    staticClass: "quote"
  }, [_c('p', {
    staticClass: "quotea"
  }, [_vm._v("["), _c('em', {
    staticClass: "italic"
  }, [_vm._v("…")]), _vm._v("] "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("the hostility against me is strong")]), _vm._v(" ["), _c('em', {
    staticClass: "italic"
  }, [_vm._v("…")]), _vm._v("] "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("send me garrison troops")]), _vm._v(" ["), _c('em', {
    staticClass: "italic"
  }, [_vm._v("…")]), _vm._v("] "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The ‘Apiru plunder all the lands of the king. If there are archers (here) in this year, the lands of the king, my lord, will remain (intact)")]), _vm._v(" ["), _c('em', {
    staticClass: "italic"
  }, [_vm._v("…")]), _vm._v("] "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("I was almost killed by the men of the land of Nubia in my own house")]), _vm._v(" ["), _c('em', {
    staticClass: "italic"
  }, [_vm._v("…")]), _vm._v("] "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("There is not a single governor (remaining) to the king")]), _vm._v(" ["), _c('em', {
    staticClass: "italic"
  }, [_vm._v("…")]), _vm._v("] "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The entire land of the king has revolted")]), _vm._v(" ["), _c('em', {
    staticClass: "italic"
  }, [_vm._v("…")]), _vm._v("] "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("a town of the land of Jerusalem, Bit-Lahmi by name, a town belonging to the king, has gone over to the people of Keilah")]), _vm._v("."), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/35_Notes#fn1-13",
      "id": "rfn1-13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("13")])])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Notwithstanding intermittent conflicts between nations, the cohesion of the eastern Mediterranean region during the Late Bronze Age, depended "), _c('a', {
    attrs: {
      "id": "page_4"
    }
  }), _vm._v("upon a system of mutually respectful diplomatic relations between the so-called "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Great Kings")]), _vm._v(", who received tribute from numerous lesser rulers. In Palestine, city-states operating under Egyptian sovereignty were predominant. However, during the thirteenth and the twelfth centuries "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("BCE")]), _vm._v(", as the Iron Age unfolded, the entire system began to collapse, in response to a combination of demographic and technological changes and aggression from overseas invaders.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Probably emanating from the north-west, an alliance of Mediterranean peoples, which included the Philistines, initiated the demise of the Anatolian Hittite empire."), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/35_Notes#fn1-14",
      "id": "rfn1-14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("14")])]), _vm._v(" Egypt was also compelled to defend itself against invasion by so-called ‘Sea-Peoples’ and in the process lost control of its Palestinian territories, at a time when the Assyrian empire was relatively impotent and unable to step into the political vacuum.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Much of the northern Palestinian coast comprised Phoenician city-states such as Acco,"), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/35_Notes#fn1-15",
      "id": "rfn1-15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("15")])]), _vm._v(" Tyre and Sidon. In towns such as Gaza and Ashkelon, the Philistines established themselves on the southern Palestinian coast and it is not unreasonable to suppose that the very arrival of the ‘Sea-Peoples’ caused population movements away from the coast. In addition, the Aramaeans, who had previously occupied the fringes of the arable land around the Fertile Crescent, began to spread into the lower more productive regions."), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/35_Notes#fn1-16",
      "id": "rfn1-16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("16")])]), _vm._v(" Other ethnically, politically and religiously diverse clans and tribes were also present, particularly in the central hill country. Some may have been Semites who had lived in Palestine for centuries and there were newer settlers that included escapees from Egypt and sundry economic migrants, all contributing further to the diverse mix of races and cultures in Palestine.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Not surprisingly, the inhabitants of the settlement on the eastern slopes of Jerusalem were wholly dependent upon farming and their domestic livestock. In the semi-arid climate where even the winter rain was unreliable, technological innovations such as iron tools and improvements in the construction of terraces, gave impetus to the husbandry of fruit trees and vines, for harvesting at a different time of the year to the cereal crops grown in the plains and valley floors."), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/35_Notes#fn1-17",
      "id": "rfn1-17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("17")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The combination of the various stresses resulting from the inflows of dissimilar cultures, political disturbances, technological adjustments and the termination of Egyptian authority, altered the North-Syrian and Canaanite city-state system beyond recognition. The entire region experienced a period of political autonomy, in which the urban centres "), _c('a', {
    attrs: {
      "id": "page_5"
    }
  }), _vm._v("were replaced by new ethno-political configurations and various regions of the Levant were inhabited by different societies. The realignment of the socio-political structures resulted in new smaller settlements on the sites of the old cities and new villages springing up in the previously sparsely inhabited hill country.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The Early Iron Age villagers of the central hill country perhaps included the Israelite clans and tribes described in the Book of Judges, and "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("in those days there was no king in Israel; every man did what was right in his own eyes")]), _vm._v("."), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/35_Notes#fn1-18",
      "id": "rfn1-18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("18")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-20bbb528","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/07_Chapter01.vue
// module id = 78
// module chunks = 0